var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-scroll-to"},[_c('am-icon-button',{attrs:{"icon":_vm.icon},on:{"click":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }